<template>
  <card-modal>
    <template v-slot:header>
      <h1>Releasing {{ commit.version }}</h1>
    </template>

    <template v-slot:content>
      <ion-item>
        <ion-label position="floating">
          Release track
        </ion-label>
        <ion-select-vue
          v-model="release.release_track"
          interface="popover"
        >
          <ion-select-option
            v-for="track in releaseTrack"
            :key="track.key"
            :value="track.value"
          >
            {{ track.key }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          Release notes
        </ion-label>
        <ion-textarea-vue 
          v-model="release.release_notes" 
          rows="5"
        />
      </ion-item>

      <ion-item class="half-width-input">
        <ion-label position="floating">
          Min App Build Number (optional)
        </ion-label>
        <ion-input-vue v-model="release.min_app" />
      </ion-item>

      <ion-item class="half-width-input">
        <ion-label position="floating">
          Max App Build Number (optional)
        </ion-label>
        <ion-input-vue v-model="release.max_app" />
      </ion-item>

      <ion-item class="half-width-input">
        <ion-label position="floating">
          Min Bridge Build Number (optional)
        </ion-label>
        <ion-input-vue v-model="release.min_bridge" />
      </ion-item>

      <ion-item class="half-width-input">
        <ion-label position="floating">
          Max Bridge Build Number (optional)
        </ion-label>
        <ion-input-vue v-model="release.max_bridge" />
      </ion-item>
    </template>

    <template v-slot:footer>
      <ion-button 
        expand="full" 
        class="ion-margin-top" 
        @click="save"
      >
        <ion-spinner
          v-if="busy"
          color="me"
        />
        <ion-text
          v-else
          color="light"
        >
          Save
        </ion-text>
      </ion-button>
    </template>
  </card-modal>
</template>

<script>
import { IonInputVue, IonSelectVue, IonTextareaVue } from '@modus/ionic-vue'
import { modalController } from '@modus/ionic-vue'

import CardModal from '../common/CardModal'
import store from '../state'
import { releaseTrack } from './releaseTrack';

export default {
  components: {
    CardModal,
    IonInputVue,
    IonSelectVue,
    IonTextareaVue
  },
  props: {
    commit: {
      type: Object,
      required: true
    },
    release: {
      type: Object,
      default: () => ({
        release_notes: '',
        release_track: 'alpha-track',
        min_app: null,
        max_app: null,
        min_bridge: null,
        max_bridge: null,
      })
    }
  },
  data() {
    return {
      busy: false,
      releaseTrack
    }
  },
  methods: {
    async save() {
      const project = this.commit.project_id
      const commitId = this.commit.id
      const release = this.release

      this.busy = true

      store.dispatch('storeRelease', { project, commitId, release })
        .then(() => modalController.dismiss())
        .finally(() => this.busy = false)
    }
  }
}
</script>

<style scoped>
  .half-width-input {
    width: 50%;
    float: left;
  }
</style>